module.exports = __webpack_public_path__ + "assets/img/epson.68b2cfd9.png";